export const environment = {
  production: true
};



// WEBPACK FOOTER //
// /Users/manuel/Sites/doxasoft/fenyofarm/csemete/src/environments/environment.ts